import { buttonTypes } from '../components/button/button.component';

export interface IHistoryActionButton {
  type: buttonTypes;
  text: string;
  icon?: string;
  callback?: any;
}

export interface IHistoryColumnData {
  key: string;
  type: HISTORY_COLUMN_TYPE;
  css?: string;
}

export enum HISTORY_COLUMN_TYPE {
  TEXT = 'TEXT',
  DATE = 'DATE'
}
